import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, Clock } from 'lucide-react';
import { blogPosts } from '../data/mock';

const Insights = () => {
  const [filter, setFilter] = useState('All');
  
  const categories = ['All', 'AI', 'Sustainability', 'Policy'];
  
  const filteredPosts = filter === 'All' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === filter);

  return (
    <div style={{ paddingTop: '80px', background: 'var(--bg-primary)' }}>
      {/* Hero */}
      <section style={{
        padding: '100px 7.6923%',
        background: 'var(--bg-primary)',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h1 className="display-huge" style={{ marginBottom: '24px' }}>
            Insights
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Perspectives on AI, autonomous agents, climate policy, and sustainability strategy.
          </p>
        </div>
      </section>

      {/* Filters */}
      <section style={{ padding: '0 7.6923% 60px' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', justifyContent: 'center', gap: '16px', flexWrap: 'wrap' }}>
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setFilter(cat)}
              style={{
                background: filter === cat ? 'var(--brand-primary)' : 'rgba(255, 255, 255, 0.1)',
                color: filter === cat ? '#000000' : 'var(--text-primary)',
                border: 'none',
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
            >
              {cat}
            </button>
          ))}
        </div>
      </section>

      {/* Blog Posts */}
      <section style={{ padding: '0 7.6923% 100px' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
            gap: '40px'
          }}>
            {filteredPosts.map((post) => (
              <Link
                key={post.id}
                to={`/insights/${post.slug}`}
                style={{ textDecoration: 'none' }}
              >
                <div
                  style={{
                    background: 'var(--bg-secondary)',
                    border: '1px solid var(--border-subtle)',
                    overflow: 'hidden',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'all 0.4s ease'
                  }}
                  className="dark-hover"
                >
                  <img
                    src={post.heroImage}
                    alt={post.title}
                    style={{
                      width: '100%',
                      height: '240px',
                      objectFit: 'cover'
                    }}
                  />
                  <div style={{ padding: '32px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <div style={{
                      fontSize: '14px',
                      color: 'var(--brand-primary)',
                      marginBottom: '12px',
                      fontWeight: 500
                    }}>
                      {post.category}
                    </div>
                    <h3 className="heading-3" style={{ marginBottom: '16px', color: 'var(--text-primary)' }}>
                      {post.title}
                    </h3>
                    <p className="body-small" style={{ marginBottom: '24px', flex: 1 }}>
                      {post.summary}
                    </p>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                      marginBottom: '16px',
                      paddingTop: '16px',
                      borderTop: '1px solid var(--border-subtle)',
                      fontSize: '14px',
                      color: 'var(--text-muted)'
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <Calendar size={16} />
                        {new Date(post.publishDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <Clock size={16} />
                        {post.readTime}
                      </div>
                    </div>
                    <div style={{
                      fontSize: '14px',
                      color: 'var(--text-secondary)'
                    }}>
                      By {post.author}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Insights;
